import Error404Page from 'app/main/errors/Error404Page';
import DataLoader from 'app/ui_v2/components/data-loader/DataLoader';
import { lazy, Suspense } from 'react';
import { RouteObject } from 'react-router';

import { getInspectorProfileRoutes } from '../agency-routes/inspectorProfileRoutes';

const AgencyInspectors = lazy(
  () => import('../../../../main/backoffice/agency-inspectors/BackofficeAgencyInspectorsPage'),
);

export const backOfficeInspectorsRoutes: RouteObject[] = [
  {
    path: '',
    element: (
      <Suspense fallback={<DataLoader />}>
        <AgencyInspectors />
      </Suspense>
    ),
  },
  {
    path: ':id',
    children: getInspectorProfileRoutes([]),
  },
  {
    path: '*',
    element: <Error404Page />,
  },
  {
    path: ':any/*',
    element: <Error404Page />,
  },
];
